const noResumeUrlStorage = {
  findAllUploads: () => Promise.resolve([]),
  findUploadsByFingerprint: () => Promise.resolve([]),
  removeUpload: () => Promise.resolve(),
  addUpload: () => Promise.resolve(null),
};

export const BUNNY_TUS_OPTIONS = {
  endpoint: 'https://video.bunnycdn.com/tusupload',
  allowedMetaFields: ['AuthorizationSignature', 'AuthorizationExpire', 'LibraryId', 'VideoId'],
  urlStorage: noResumeUrlStorage,
  storeFingerprintForResuming: false,
  onBeforeRequest: async (req, file) => {
    if (!file.meta.AuthorizationSignature) {
      throw new Error('Ocorreu um erro ao enviar o vídeo');
    }
    req.setHeader('AuthorizationSignature', file.meta.AuthorizationSignature);
    req.setHeader('AuthorizationExpire', file.meta.AuthorizationExpire);
    req.setHeader('LibraryId', file.meta.LibraryId);
    req.setHeader('VideoId', file.meta.VideoId);
    return req;
  },
};
